export function hasBrandSeparation(
  themeStyles?: Record<string, string>
): boolean {
  return (
    themeStyles?.['--brand-separation-shadow'] !== 'none' &&
    themeStyles?.['--brand-separation-border'] !== 'transparent'
  );
}

export const PROJECT_CHAT_CLASSNAMES = {
  embed:
    'w-full min-h-0 flex-1 max-w-full overflow-hidden border-none sm:rounded-t-none',
  widget: 'min-h-0 flex-1 overflow-hidden border-t-none sm:rounded-t-none',
  usability: 'size-full',
};
